<template>
<div
	:class="`formulate-input-element formulate-input-element--${context.type}`"
	:data-type="context.type"
	autocomplete="off"
	>
    
    <div class="input-select">
		<model-list-select
			autocomplete="off"
			:list="context.options"
			v-model="formatted"
			v-bind="context.attributes"
			@input="onSelect"
		/>
	</div>
    
</div>
</template>


<script>
// PROPS
// option-value="code"
// option-text="name"

import { ModelListSelect  } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	components: {
		ModelListSelect,
	},
	data() {
		return {};
	},
	computed: {
		formatted: {
			get: function() {
				return this.context.model;
			},
			set: function(newValue) {
				this.context.model = newValue;
			},
		},
	},
	methods:{
		onSelect(selected) {
			this.$emit('selected', selected)
		},

	}
}
</script>

<style scoped>
.input-select /deep/ .ui.selection.dropdown{
    border-radius: .3em;
	padding: .75em;
	color: #000;
	border: none;
	background-color:transparent;
}

.input-select /deep/ .ui.selection.dropdown .menu{
	border: 1px solid #d8d8d8;
}

/* .input-select /deep/ .ui.selection.active.dropdown:hover,
.input-select /deep/ .ui.selection.active.dropdown:hover .menu{
	    border: none;
} */

.input-select /deep/ .ui.selection.dropdown>.delete.icon, 
.input-select /deep/ .ui.selection.dropdown>.dropdown.icon, 
.input-select /deep/ .ui.selection.dropdown>.search.icon{
	padding: .8em;
}
.input-select /deep/ .ui.search.dropdown>input.search{
padding: .75em;
}
</style>
